import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



import { _datiDetail } from '../../components/detail/detail.component';

@Component({
  selector: 'app-ana-produttori',
  templateUrl: './ana-produttori.component.html',
  styleUrls: ['./ana-produttori.component.css']
})
export class AnaProduttoriComponent implements OnInit {
    isDrawerOpen=false;
    id: string;
   
    toolbarContent = [{
      widget: 'dxButton',
      location: 'before',
      options: {
          icon: 'menu',
          onClick: () => this.isDrawerOpen = !this.isDrawerOpen,
      }
  }];
  i:{id:number, stato:boolean | Function}[]=[];
  passaDettagli: _datiDetail[]=[
    {chiave:"id_anagrafica", titolo:'Unità Locali', api:'unitalocali',
    subDetail:[
        {chiave:"id_unitalocale", titolo:'Automezzi per unità locale', api:'automezzi' }],},
    {chiave:"id_anagrafica", titolo:'Automezzi', api:'automezzi'}

  ];
  constructor(private router:Router, private route: ActivatedRoute) {

  }



  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id')
    //alert(this.id);
    console.log('passa dettagli ', this.passaDettagli);

  }
  onSelectionChanged(event){
      this.isDrawerOpen=false;
      console.log(event); // Record elezionato
     // alert(event.id);
  }

  logga(event){

  }
  cambiotasto(n:number){

    ;
  }
}
